const apiURLBuilder = require('core/apiURLBuilder');
const Api = require('services/api');
const {
    RA_SUITABILITY_TEST_RESET_OTP,
    RA_SUITABILITY_TEST_RELOAD_OTP,
    RA_SUITABILITY_TEST_VALIDATE_OTP_SUCCESS,
    RA_SUITABILITY_TEST_VALIDATE_OTP_ERROR,
} = require('constants/RAConstants/actionTypes');
import checkStatusActions from 'actions/RACheckStatus';
import loginRoboActions from 'actions/loginRoboActions';
import suitabilityActions from 'actions/RASuitabilityTest';

const resetOTP = () => ({
    type: RA_SUITABILITY_TEST_RESET_OTP,
});

const loadOTP = () => ({
    type: RA_SUITABILITY_TEST_RELOAD_OTP,
    payload: {
        loadingReloadOTPCode: true,
    },
});

const otpSuccess = () => ({
    type: RA_SUITABILITY_TEST_VALIDATE_OTP_SUCCESS,
    payload: {
        isValidOTP: true,
        wasOTPValidated: true,
        loadingReloadOTPCode: false,
    },
});

const otpFailure = () => ({
    type: RA_SUITABILITY_TEST_VALIDATE_OTP_ERROR,
    payload: {
        isValidOTP: false,
        wasOTPValidated: true,
        loadingReloadOTPCode: false,
    },
});

const verifyLoginOtpRobo = (payload, accessToken, callback) => dispatch => {
    dispatch(loadOTP());
    const request = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: payload,
    };
    return Api.post(apiURLBuilder.getURL('verifyLoginOtpRobo'), request)
        .then(response => {
            if (response && response.body.tokenCredential) {
                dispatch(otpSuccess());
                dispatch(loginRoboActions.loginRoboSuccess(response.body));
                dispatch(checkStatusActions.checkStatus(accessToken)).then(() =>
                    dispatch(suitabilityActions.getTestQuestions(accessToken))
                );
                callback(true);
            } else {
                dispatch(otpFailure());
            }
        })
        .catch(() => {
            dispatch(otpFailure());
        });
};

const postVerifyRoboOtp = (payload, accessToken, callback) => dispatch => {
    dispatch(loadOTP());
    const request = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: payload,
    };
    return Api.post(apiURLBuilder.getURL('verifyOtpRobo'), request)
        .then(() => {
            dispatch(otpSuccess());
            callback(accessToken);
        })
        .catch(() => {
            dispatch(otpFailure());
        });
};

export default {
    resetOTP,
    loadOTP,
    otpSuccess,
    otpFailure,
    verifyLoginOtpRobo,
    postVerifyRoboOtp,
};
